import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import { createAxiosInstance } from "../utils/AxiosInstance";
import { useConfig } from "../utils/ConfigContext";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

const CenterOpdComparisonReport = () => {
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    const [groups, setGroups] = useState([]);

    const [currentMonth, setCurrentMonth] = useState(moment().format('YYYY-MM'));
    const [lastMonth, setLastMonth] = useState(moment().subtract(1, "month").format("YYYY-MM"));
    const [lastTwoMonth, setLastTwoMonth] = useState(moment().subtract(2, "month").format("YYYY-MM"));

    const [centerIds,setCenterIds] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitted Data:", currentMonth, lastMonth, lastTwoMonth);
    };


    const getMonthOptions = () => ({
        plugins: [
            new monthSelectPlugin({
                shorthand: true,
                dateFormat: "Y-m",
                altFormat: "F Y",
            })
        ]
    });
    const formatYearMonth = (date) => {
        if (!date) return null;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        return `${year}-${month}`;
    };
    const formatMonth = (date) => {
        if (!date) return "";
        return moment(date).format("MMMM YYYY");
    }
    const myGroups = async(userId)=> {
        const res  = await AxiosInstance.get('/centergroups');
        setGroups( res.data.data || [] );

    }

    // const handleChangeGroup = (e)=>{
    //     // e.target.value

    // }

    useEffect( ()=>{
        myGroups();
    },[]);

    return (
        <div className="card shadow-sm">
            <div className="card-body">

                <form onSubmit={handleSubmit}>

                    <div className="row g-3">
                        {/* groups */}
                        <div className="col-md-2">
                            <label className="form-label">Select Center Groups</label>
                            <select name="mygroups" id="mygroups"  className="form-control">
                               {groups.map( (group) => (
                                  <option key={group.id} value={group.id} >{group.name}</option>
                               ))}
                            </select>
                        </div>

                        {/* Current Month */}
                        <div className="col-md-2">
                            <label className="form-label">Current Month</label>
                            <Flatpickr
                                value={currentMonth}
                                onChange={(dates) => setCurrentMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="current_month"
                            />
                        </div>

                        {/* Last Month */}
                        <div className="col-md-2">
                            <label className="form-label">Last Month</label>
                            <Flatpickr
                                value={lastMonth}
                                onChange={(dates) => setLastMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="last_month"
                            />
                        </div>

                        {/* Two Months Ago */}
                        <div className="col-md-2">
                            <label className="form-label">Two Months Ago</label>
                            <Flatpickr
                                value={lastTwoMonth}
                                onChange={(dates) => setLastTwoMonth(formatYearMonth(dates[0]))}
                                options={getMonthOptions()}
                                className="form-control"
                                name="last_two_month"
                            />
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                            <button type="submit" className="btn btn-primary">
                                Apply Filter
                            </button>

                        </div>

                    </div>



                </form>
                <div className="mt-10">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th className="text-center">Center Name</th>
                                <th className="text-center">{formatMonth(currentMonth)} Conversion/OPD</th>
                                <th className="text-center">{formatMonth(lastMonth)} Conversion/OPD</th>
                                <th className="text-center">{formatMonth(lastTwoMonth)} Conversion/OPD</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={4}>No Data found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default CenterOpdComparisonReport;